import { createBehavior } from '@area17/a17-behaviors';
import Swiper from 'swiper';

const timeline = createBehavior(
  'timeline',
  {
    onYearClick(evt) {
      const year = evt.currentTarget.getAttribute('data-timeline-year');
      const slideForYear = this.$swiper.querySelector(
        `[data-timeline-swiper-year="${year}"`
      );

      let i = 0;
      for (const slide of this.swiper.slides) {
        if (slide === slideForYear) {
          this.swiper.slideTo(i);
        }
        i++;
      }
    },
  },
  {
    init() {
      this.$yearScroll = this.getChild('year-scroll');
      this.$years = this.getChildren('year');
      this.$swiper = this.getChild('swiper');

      const $initialActiveYear = Array.from(this.$years).find((el) =>
        el.getAttribute('[data-selected]')
      );
      this.activeYear = $initialActiveYear
        ? $initialActiveYear.getAttribute('data-timeline-year')
        : null;

      for (const $year of this.$years) {
        $year.addEventListener('click', this.onYearClick);
      }

      this.swiper = new Swiper(this.$swiper, {
        modules: [],
        direction: 'horizontal',
        grabCursor: true,
        initialSlide: 0,
        on: {
          activeIndexChange: (swiper) => {
            const activeSlide = swiper.slides[swiper.activeIndex];
            const activeYear = activeSlide.getAttribute(
              'data-timeline-swiper-current-year'
            );
            if (activeYear !== this.activeYear) {
              let $activeYear;
              this.activeYear = activeYear;
              for (const $year of this.$years) {
                const year = $year.getAttribute('data-timeline-year');
                if (year === activeYear) {
                  $year.setAttribute('data-selected', '');
                  $activeYear = $year;
                } else {
                  $year.removeAttribute('data-selected');
                }
              }
              if ($activeYear) {
                this.$yearScroll.scrollLeft = $activeYear.offsetLeft;
                // TODO -- add to overflowed-state only (it's causing a vertical scroll)
                // $activeYear.scrollIntoView({
                //   behavior: 'smooth',
                // });
              }
            }
          },
        },
      });
    },
    destroy() {
      this.swiper.destroy();
      for (const $year of this.$years) {
        $year.removeEventListener('click', this.onYearClick);
      }
    },
  }
);

export default timeline;
